import React, { useState } from 'react';
import dayjs from 'dayjs';
import DatePickerWithRange from '../../../../../../../components/Common/UI/DateRange';
import { IDates } from '../index';
import Label from '../../../../../../../components/Common/UI/Label';
import { Input } from '../../../../../../../components/Common/UI/Input';
import { Button } from '../../../../../../../components/Common/UI/Button';
import Icons from '../../../../../../../components/Common/Icons/Icons';

const defaultValues: IDates = {
  from: dayjs('2023-07-27T05:00:00Z').toDate(),
  to: dayjs('2024-08-27T05:00:00Z').toDate(),
};

function AccountChecks() {
  const [state, setState] = useState<IDates>(defaultValues);

  const handleOnChange = (from?: Date, to?: Date) => {
    if (from && to) {
      setState({ from, to });
    }
  };

  return (
    <div>
      <div className="flex gap-[20px] mb-[15px]">
        <DatePickerWithRange
          triggerClassName="min-w-[260px] w-[260px] mt-[13px]"
          iconClassName="[&_rect]:stroke-addition5 [&_path]:stroke-addition5"
          dataFormat="MMM d, yyyy"
          handleOnChange={handleOnChange}
          label="Check Date"
          from={state.from}
          to={state.to}
        />
        <div>
          <Label>Check Amount</Label>
          <div className="flex gap-[10px] items-center">
            <Input label="From" variant="white" placeholder="" />
            <Input label="To" variant="white" placeholder="" />
          </div>
        </div>
        <div>
          <Label>Check Number</Label>
          <div className="flex gap-[10px] items-center">
            <Input label="From" variant="white" placeholder="" />
            <Input label="To" variant="white" placeholder="" />
          </div>
        </div>
      </div>
      <div className="flex gap-[10px] justify-end">
        <Button variant="secondary">Clear</Button>
        <Button className="flex items-center gap-[5px] px-[20px]">
          <Icons.Search />
          Search
        </Button>
      </div>
    </div>
  );
}

export default AccountChecks;
